import axios from "@/libs/axiosV1";
import { reactive, toRefs } from "@vue/composition-api";
import { AxiosResponse } from "axios";

interface RootState {
    customer: { orgId?: string };
    loading: boolean;
    error: boolean;
    isFetching: boolean;
}

const state: RootState = reactive({
    customer: {
        orgId: undefined,
    },
    loading: false,
    error: false,
    isFetching: false,
});

export default function useCustomer() {
    const fetchOrgIdByDomain = async (domain: string): Promise<AxiosResponse<{ orgId?: string }>> => {
        state.loading = true;
        const customer = axios.get(
            `${process.env.VUE_APP_API_GATEWAY?.replace("v1", "v2")}/customers/domain/${domain}/org-id`
        );

        customer
            .then((response) => (state.customer = { ...state.customer, orgId: response.data.orgId }))
            .finally(() => (state.loading = false));

        return customer;
    };

    return {
        fetchOrgIdByDomain,
        ...toRefs(state),
    };
}
